<template>
  <nav class="micarrito" id="micarrito">

    <div class="closeMyCart" @click="closeMyCart" >CERRAR</div>

    <!-- Header -->
    <div class="box-header">
      <div class="title">Mi carrito</div>
      <div class="box-cantidad">
        Total de productos: <span class="cantidad">{{cart_items.length}}</span>.
      </div>
    </div>

    <!-- Product List -->
    <div class="box-product-list">

      <div v-for="item in cart_items" :key="item.product.id" class="box-item">
        <div class="item-box-photo">
          <a :href="`/product/${item.product.id}`">
            <img :src="item.product.imageURL_M" class="item-photo">
          </a>
        </div>
        <div class="item-box-description">
          <div class="item-title">{{item.product.titulo}}</div>
          <div class="item-price">{{item.product.precio_mayorista | currency }} + IVA</div>
          <div class="item-cantidad"> Cantidad: <span class="numCantidad">{{item.quantity}} unidades</span></div>
        </div>
        <div class="cartQuitar" @click.prevent="removeFromCart(item)">
          <img src="/static/img/app/btn-close-grey.svg">
        </div>
      </div>


    </div>

    <!-- Footer -->
    <div class="box-footer">

        <div class="box-subtotal" v-if="discount_value>0">

            Subtotal. <span class="price pull-right"> {{cart_subtotal | currency }}</span>
        </div>
        <div class="box-subtotal" v-if="discount_value>0">

            Descuento. <span class="price pull-right">- ({{discount_value | currency }})</span>
        </div>
      <div class="box-subtotal">

        Total. <span class="price pull-right">{{cart_total | currency }} + IVA</span>
      </div>


      <a class="btn-submit"  @click.prevent="goToCart" v-if="cart_total>=purchaseMin && cart_total<=purchaseMax">
        FINALIZAR COMPRA
      </a>
      <div v-else>
        El minimo de compra es {{purchaseMin | currency}} y el máximo es {{ parseFloat(purchaseMax) | currency}}.
      </div>

    </div>

  </nav>

</template>

<script>
import Api from "@/Api";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            categories: []
        };
    },
    computed: {
        ...mapGetters([
            "user",
            "isLogged",
            "cart_total",
            "cart_subtotal",
            "cart_items",
            "purchaseMin",
            "purchaseMax",
            "discount_value"
        ])
    },
    methods: {
        closeMyCart() {
            $("nav.micarrito, .overlay-micarrito").removeClass("open");
            $("body").removeClass("lock");
        },
        goToCart() {
            $("nav.micarrito, .overlay-micarrito").removeClass("open");
            $("body").removeClass("lock");
            this.$router.push({ name: "CartDetail" });
        },
        removeFromCart(item) {
            this.$store.dispatch("removeFromCart", { item }).then(success => {
                /* this.$toasted.show("Item " + item.product.titulo + " removido ", {
            theme: "bubble",
            position: "top-right",
            duration : 5000,
            action : {
              text : 'Deshacer',
              onClick : (e, toastObject) => {
                var product = item.product;
                var quantity = item.quantity;
                this.$store.dispatch("addToCart", {product,quantity}).then( product =>{
                  toastObject.goAway(0);
                });

              }
            }
          }); */

                if (this.cart_items.length <= 0) {
                    $("nav.micarrito, .overlay-micarrito").removeClass("open");
                    $("body").removeClass("lock");
                }
            });
        }
    },
    mounted() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Carrito.vue